import React from "react";
import { Tooltip } from "antd";
import {
  formatProductTitle,
  formatLocationTitle,
  formatCustomSpecsFromApi,
  isCustomSpecProduct,
  SPEC_TYPE,
} from "../utils/utils";
import alertFillIcon from "../../../../assets/images/product/specmanager/alert-fill.svg";
import closeFillIcon from "../../../../assets/images/product/specmanager/close-fill.svg";
import shieldCheckIcon from "../../../../assets/images/product/specmanager/shield-check-line.svg";
import informationIcon from "../../../../assets/images/product/specmanager/information-line.svg";
import "./SelectedProductList.css";

export default function SelectedProductList({
  products,
  identifierFields,
  loading,
  readOnly = false,
  onRemoveProduct,
  specType = SPEC_TYPE.PRODUCT,
  removeBlockedTooltip = "This product is under testing and cannot be removed.",
}) {
  const isEnvironmentSpec = specType === SPEC_TYPE.ENVIRONMENT;
  const emptyMessage = isEnvironmentSpec
    ? "No locations selected. Use All Locations below to add locations."
    : "No products selected. Use All Products below to add products.";

  if (!products.length) {
    return (
      <div className="SelectedProductList_Empty">
        {emptyMessage}
      </div>
    );
  }

  const formatItemTitle = (productRow) => {
    if (isEnvironmentSpec) {
      return formatLocationTitle(productRow, identifierFields);
    }
    return formatProductTitle(productRow, identifierFields);
  };

  return (
    <ul className="SelectedProductList_List">
      {products.map((productRow) => {
        const isNonRemovable = productRow.test_submitted === true;
        const isCustom = isCustomSpecProduct(productRow);
        const title = formatItemTitle(productRow);
        const customSpecsLabel = formatCustomSpecsFromApi(productRow.custom_specs);
        const badgeIcon = isCustom ? informationIcon : shieldCheckIcon;
        const typeBadgeClassName = [
          "SelectedProductList_TypeBadge",
          isCustom && "SelectedProductList_TypeBadge--custom",
          !isCustom && "SelectedProductList_TypeBadge--standard",
        ].filter(Boolean).join(" ");

        return (
          <li key={productRow.product_id} className="SelectedProductList_Item">
            <Tooltip title={title} placement="left">
              <span className="SelectedProductList_Text">{title}</span>
            </Tooltip>
            <div className="SelectedProductList_Right">
              <span className={typeBadgeClassName}>
                <img
                  src={badgeIcon}
                  alt=""
                  className="SelectedProductList_TypeBadgeIcon"
                  aria-hidden
                />
                <span className="SelectedProductList_TypeBadgeText">
                  {isCustom && (
                    <>
                      Custom
                      {customSpecsLabel && `: ${customSpecsLabel}`}
                    </>
                  )}
                  {!isCustom && "Standard"}
                </span>
              </span>
              {!readOnly && isNonRemovable && (
                <Tooltip title={removeBlockedTooltip} placement="left">
                  <span className="SelectedProductList_AlertIcon" aria-hidden>
                    <img src={alertFillIcon} alt="" width={20} height={20} />
                  </span>
                </Tooltip>
              )}
              {!readOnly && !isNonRemovable && (
                <button
                  type="button"
                  className="SelectedProductList_CloseButton"
                  disabled={loading}
                  aria-label="Remove product"
                  onClick={() => onRemoveProduct(productRow.product_id)}
                >
                  <img src={closeFillIcon} alt="" width={8} height={8} />
                </button>
              )}
            </div>
          </li>
        );
      })}
    </ul>
  );
}
